import {useNotification} from '@hconnect/uikit/src/common'
import {useMutation} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useErrorHandler} from 'react-error-boundary'
import {useTranslation} from 'react-i18next'

import {GET_PINNED_GLOBAL_MEASUREMENT_NAME_KEY} from '../../api/queries/getPinnedGlobalMeasurementName'
import {DistributedCacheResponse} from '../../types/DistributedCache'

import {mutations} from '@settings/api/mutations'
import {setSettingsQueryData} from '@settings/modules/common/providers'
import {ErrorResponse} from '@settings/modules/common/types'
import {notifyIfErrorMessage} from '@settings/modules/common/utils'

type PinGlobalMeasurementNameParameters = Parameters<typeof mutations.pinGlobalMeasurementName>[0]

export function usePinGlobalMeasurementNameMutation() {
  const {notify} = useNotification()
  const raiseError = useErrorHandler()
  const {t} = useTranslation()

  return useMutation<void, AxiosError<ErrorResponse>, PinGlobalMeasurementNameParameters>({
    mutationFn: mutations.pinGlobalMeasurementName,
    onSuccess: (_data, variables) => {
      const nextPinnedData: DistributedCacheResponse = {
        keyIdentifier: variables.keyIdentifier,
        value: variables.value
      }

      setSettingsQueryData(
        GET_PINNED_GLOBAL_MEASUREMENT_NAME_KEY,
        [variables.keyIdentifier],
        nextPinnedData
      )
    },
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      notifyIfErrorMessage(
        t('measurementsSettings.mutations.pinGlobalMeasurementNameError', {
          details: errorDetails
        }),
        raiseError,
        notify
      )
    }
  })
}
